import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import axios from '@src/service/axios';

export const getEmailConfiguration = createAsyncThunk('emailConfigSlice/getEmailConfiguration', async () => {
    try {
        const response = await axios.get('/emailconfig', {
            headers: { 'Content-Type': 'application/json' },
            loader: true
        });
        return Promise.resolve(response.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createEmailConfiguration = createAsyncThunk('emailConfigSlice/createEmailConfiguration', async (data, { dispatch }) => {
    try {
        const response = await axios.post('/emailconfig', data, {
            headers: { 'Content-Type': 'application/json' }
        });
        toast.success(response?.data?.message || 'Email configuration saved successfully.');
        await dispatch(getEmailConfiguration());
        return Promise.resolve(response.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const deleteEmailConfig = createAsyncThunk('emailConfigSlice/deleteEmailConfig', async (id, { dispatch }) => {
    try {
        const response = await axios.delete('/emailconfig/' + id, {
            headers: { 'Content-Type': 'application/json' },
            loader: true
        });
        toast.success(response?.data?.message || 'Email configuration deleted successfully.');
        await dispatch(getEmailConfiguration());
        return Promise.resolve(response.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateStatus = createAsyncThunk('emailConfigSlice/updateStatus', async (id, { dispatch }) => {
    try {
        const response = await axios.put('/emailconfig/status/' + id, undefined, {
            headers: { 'Content-Type': 'application/json' },
            loader: true
        });
        toast.success(response?.data?.message || 'Status updated successfully!');
        await dispatch(getEmailConfiguration());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const emailConfigSlice = createSlice({
    name: 'emailConfigSlice',
    initialState: {
        emailConfigurationData: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getEmailConfiguration.fulfilled, (state, action) => {
            state.emailConfigurationData = action?.payload;
        });
    }
});

export default emailConfigSlice.reducer;
